import { Component, ChangeDetectorRef, DestroyRef, HostListener, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDrawerMode, MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { CommonService } from '../../../services/common.service';
import { HasPermissionDirective } from '../../../directives/has-permission.directive';
import {
  RBAC_DEVICE_LIST_VIEW_PERMISSIONS,
  RbacPermissions,
} from '../../../services/rbac/rbac-permissions';
import { RbacService } from '../../../services/rbac/rbac.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    HasPermissionDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  readonly RbacPermissions = RbacPermissions;

  rbacNavReady = false;

  readonly deviceListMenuPermissions = RBAC_DEVICE_LIST_VIEW_PERMISSIONS;

  readonly otaMenuPermissions = [
    RbacPermissions.OTA_ConfigurationList_View,
    RbacPermissions.OTA_ConfigurationList_Update,
    RbacPermissions.OTA_UploadConfigurationFile,
    RbacPermissions.OTA_ConfigurationHistory_View,
    RbacPermissions.OTA_ConfigurationHistory_Export,
  ];

  readonly userMgmtMenuPermissions = [
    RbacPermissions.UserMgmt_Customer_View,
    RbacPermissions.UserMgmt_Group_View,
    RbacPermissions.UserMgmt_UserList_View,
    RbacPermissions.UserMgmt_GroupAssignment,
    RbacPermissions.UserMgmt_RolePermission,
  ];

  readonly tealMenuPermissions = [
    RbacPermissions.TealInte_SIMInfo,
    RbacPermissions.TealInte_APILog,
    RbacPermissions.TealInte_OperationRes,
  ];

  private readonly rbacService = inject(RbacService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor(private authService: AuthService, private router: Router, 
    public commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.syncRbacNavReady();

    this.rbacService.contextChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.syncRbacNavReady();
        this.cdr.markForCheck();
      });

    this.rbacService
      .ensureContextLoaded()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.syncRbacNavReady();
        this.cdr.markForCheck();
      });
  }

  private syncRbacNavReady(): void {
    this.rbacNavReady = this.rbacService.isContextReady();
  }

  isExpanded = true;
  hoverVisible = false;
  hoverText = '';
  hoverIcon = '';
  hoverTop = 0;
  isProfileMenuVisible = false;

  active(route: string): boolean {
    const url = this.router.url.split('?')[0];
    return url === route || url.startsWith(route + '/');
  }

  // isActive(route: string): boolean {
  //   return this.router.url === route;
  // }

  // navigationItems = [
  //   { icon: 'device_hub', label: 'DEVICES', route: '/device-list' },
  //   { icon: 'publish', label: 'ONBOARDING', route: '/onboarding' },
  //   { 
  //     icon: 'settings_input_antenna', 
  //     label: 'OTA', 
  //     route: '/ota/configuration-list', 
  //     children: [
  //         { label: 'Configuration List', route: '/ota/configuration-list', default: true },
  //         { label: 'Upload Configuration File', route: '/ota/upload-configuration-file' },
  //         { label: 'Configuration History', route: '/ota/configuration-history' }
  //     ]
  //   },
  // ];
  // expandedItem: string | null = null;
  // toggleSubmenu(label: string, children?: any[]) {
  //   if (this.expandedItem === label) {
  //     this.expandedItem = null;
  //   } else {
  //     this.expandedItem = label;
  //     if (children && children.length > 0 && !children.some(child => this.isActive(child.route))) {
  //       this.router.navigateByUrl(children[0].route);
  //     }
  //   }
  // }
  // isActive(route: string): boolean {
  //   return this.router.url.includes(route);
  // }

  toggleProfileMenu(event: Event): void {
    event.stopPropagation();
    this.isProfileMenuVisible = !this.isProfileMenuVisible;
  }
  @HostListener('document:click') // Close dropdown when clicking anywhere else
  closeProfileMenu(): void {
    this.isProfileMenuVisible = false;
  }

  logout(): void {
    this.authService.logout();
  }

  getUserFullName(): string {
    return this.authService.getDisplayName();
  }

  navigateToOnboarding(): void {
    this.commonService.reloadComponent();
  }
  
}
